

















import Vue from "vue";
import store from "@/store";

import firebase from "@/plugins/firebase";

export default Vue.extend({
  name: "App",
  data: () => ({
    //
  }),
  computed: {
    isLogin() {
      return store.getters.isSignIn;
    },
  },
  methods: {
    clickLogout: () => {
      firebase.signOut();
    },
  },
});
